import { useSnackbar } from "notistack";
import { Navigate } from "react-router-dom";

/**
 * ProtectedRoute Component
 *
 * A wrapper component that protects routes by checking if the user is authenticated.
 * If the user is not authenticated (i.e., no token found in localStorage), they are redirected to the login page with a warning.
 * If the user is authenticated, it renders the child components.
 *
 * Props:
 * - **children** (ReactNode): The child components that are rendered if the user is authenticated.
 */
const ProtectedRoute = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const token = localStorage.getItem("token");

  if (!token) {
    enqueueSnackbar("You need to login to access this page", {
      variant: "warning",
    });
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
